import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchAssemblyLineGrid({ oeeGridParams }) {
  let token = true,
    getToken;
  while (token) {
    try {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.get, {
        route:
          `AssemblyLine/assembly?factoryId=` +
          oeeGridParams.factoryId +
          `&groupId=` +
          oeeGridParams.groupId +
          `&state=` +
          oeeGridParams.state +
          `&reasonCode=` +
          oeeGridParams.reasonCode,
      });
      const oeeGrid = data;
      yield put(Actions.setOeeGrid({ oeeGrid }));
      yield put(Actions.setLoader({ showLoader: false }));

      yield delay(60000, true);
      getToken = state => state.services.common.getIn(['ajaxCallLoopOee']);
      token = yield select(getToken);
    } catch (err) {
      console.warn(err); // Handle exception
      yield put(Actions.setLoader({ showLoader: false }));
    }
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ASSEMBLY_LINE_GRID, fetchAssemblyLineGrid)]);
}
